export const PRICE_DECIMAL_PLACES = 10
